// extracted by mini-css-extract-plugin
module.exports = {"timer":"NfumTimer_timer__tMYw9","timerIndicator":"NfumTimer_timerIndicator__4vaVf","loading":"NfumTimer_loading__vRHef","time":"NfumTimer_time__+2JHk"};